<template>
  <div v-if="quotation">
    <span
      v-for="dollarType in types"
      :key="`dollar-type-${dollarType.value}`"
      class="h3 font-weight-bold text-white mx-3"
      style="cursor: pointer"
      @click="goToListQuotations"
    >
      Dólar {{ dollarType.label }}:
      {{ quotation[dollarType.value] | toCurrencyARS }}
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import { timeUntil } from '@/util/datetime';
import { DOLLAR_QUOTATION_TIME } from '@/util/constants/schedules';

export default {
  name: 'LatestDollarQuotation',

  data() {
    return {
      timer: null,
    };
  },

  computed: {
    ...mapState('dollarQuotation', { quotation: 'currentDollarQuotation' }),

    ...mapGetters('config', { types: 'dollarOptions' }),
  },

  mounted() {
    this.$loader.disable();
    this.fetchDollarConfig();
    this.fetchCurrentDollarQuotation();
    this.$loader.enable();
  },

  updated() {
    this.updateQuotation();
  },

  methods: {
    ...mapActions('dollarQuotation', ['fetchCurrentDollarQuotation']),

    ...mapActions('config', ['fetchDollarConfig']),

    goToListQuotations() {
      if (this.$route.name !== 'DollarQuotationList') {
        this.$router.push({ name: 'DollarQuotationList' });
      }
    },

    updateQuotation() {
      if (!this.timer) {
        const miliSecondsTillUpdate = timeUntil(
          DOLLAR_QUOTATION_TIME.hour,
          DOLLAR_QUOTATION_TIME.minutes,
          DOLLAR_QUOTATION_TIME.seconds
        );

        this.timer = setTimeout(() => {
          this.fetchCurrentDollarQuotation();

          clearTimeout(this.timer);
          this.timer = null;
        }, miliSecondsTillUpdate);
      }
    },
  },
};
</script>
